import React, { useEffect, useState } from 'react';
import { getMacroMarketData, MacroMarketData } from '../../services/macroMarketService';

const MacroDominanceScreen: React.FC = () => {
  const [macro, setMacro] = useState<MacroMarketData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [history] = useState<MacroMarketData[]>([]); // Optionnel, à brancher si backend/history

  useEffect(() => {
    setLoading(true);
    getMacroMarketData()
      .then(data => {
        setMacro(data);
        setLoading(false);
      })
      .catch(e => {
        setError('Erreur lors du chargement des données macro.');
        setLoading(false);
      });
    // TODO: Charger l'historique si disponible (API à prévoir)
  }, []);

  return (
    <div style={{ maxWidth: 700, margin: '32px auto', background: '#fff', borderRadius: 16, boxShadow: '0 2px 12px #0001', padding: 32 }}>
      <h2 style={{ fontSize: 28, fontWeight: 800, color: '#1976d2', marginBottom: 24 }}>Analyse Macro Dominance</h2>
      {loading ? (
        <div>Chargement...</div>
      ) : error ? (
        <div style={{ color: '#e53935' }}>{error}</div>
      ) : macro ? (
        <>
          <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>
            Dernière mise à jour : {new Date(macro.lastUpdated).toLocaleString()}
          </div>
          <div style={{ fontSize: 22, marginBottom: 8 }}>
            BTC Dominance : <b>{macro.btcDominance.toFixed(2)}%</b>
          </div>
          <div style={{ fontSize: 22, marginBottom: 8 }}>
            ETH Dominance : <b>{macro.ethDominance.toFixed(2)}%</b>
          </div>
          <div style={{ fontSize: 18, margin: '16px 0 8px 0', color: '#1976d2' }}>
            Régime de marché : <b>{macro.btcDominance > 55 ? 'Bitcoin Dominant' : macro.btcDominance < 45 ? 'Rotation Altcoins' : macro.ethDominance > 18 ? 'Rotation ETH' : 'Neutre'}</b>
          </div>
          <div style={{ fontSize: 15, color: '#1976d2', fontWeight: 500, minHeight: 18 }}>
            {macro.btcDominance > 55
              ? 'Le capital se concentre principalement sur le Bitcoin.'
              : macro.btcDominance < 45
              ? 'Le marché semble privilégier les altcoins.'
              : macro.ethDominance > 18
              ? 'Ethereum gagne en dominance, rotation potentielle vers les smart contracts layers.'
              : 'Aucun régime dominant détecté.'}
          </div>
          {/* Historique (optionnel) */}
          {history.length > 0 && (
            <div style={{ marginTop: 32 }}>
              <h3 style={{ fontSize: 18, fontWeight: 700, color: '#1976d2' }}>Historique (non disponible en démo)</h3>
              {/* TODO: Affichage graphique ou tableau de l'historique */}
            </div>
          )}
        </>
      ) : (
        <div>Donnée macro temporairement indisponible</div>
      )}
    </div>
  );
};

export default MacroDominanceScreen;
